import styled from "styled-components";

export const Title = styled.div`
  color: ${(props) => props.theme.colors.textColor.tertiary};
  font-size: ${(props) => props.theme.scaledFontSizes.medium};
  font-weight: 600;
`;
